/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faClipboardListCheck} from '@fortawesome/pro-duotone-svg-icons';

const CourseRequestsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faClipboardListCheck} {...props} />
);

export default CourseRequestsIcon;
